import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "components/Loader";
import { Input } from "antd";
import { t } from "i18next";
import PrimaryButton from "components/common/Button/PrimaryButton";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import axiosInstance from "utils/axios";
import { formatMessage } from "utils/utility";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [inputVales, setInputValues] = React.useState({
    email: "",
    error: "",
    loading: false,
  });
  const { dir } = useAppSelector(getSettings);

  function handleSubmit() {
    const emailRegex =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!emailRegex.test(inputVales.email)) {
      setInputValues({
        ...inputVales,
        error: t("registerInvalidEmail"),
      });
      return;
    }
    setInputValues({ ...inputVales, loading: true });
    axiosInstance
      .post("users/forget-password", {
        email: inputVales.email,
      })
      .then((res) => res.data)
      .then((data) => {
        setInputValues({ ...inputVales, loading: false });
        if (data.statusCode === 200) {
          sessionStorage.setItem("email", inputVales.email);
          navigate("/user-auth/forget-password/verify");
        } else {
          setInputValues({ ...inputVales, error: formatMessage(data.message) });
        }
      })
      .catch((error) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(
            error?.response?.data?.message ?? "someThingWentWrong"
          ),
          loading: false,
        });
      });
  }

  return (
    <>
      <Loader open={inputVales.loading} position="portal" />
      <div className="flex flex-col max-w-sm w-full px-6 md:px-0" dir={dir}>
        <div className="flex flex-col gap-4 mb-6">
          {inputVales.error && (
            <p className="text-red-500 text-xs italic">
              {inputVales.error ?? "someThingWentWrong"}
            </p>
          )}
          <Input
            id="email"
            type="email"
            placeholder={t("loginEmailTextFieldPlaceholder")}
            value={inputVales.email}
            onChange={(e) =>
              setInputValues({ ...inputVales, email: e.target.value })
            }
            className="text-lg py-1"
          />
        </div>
        <div className="flex flex-col gap-3 items-center justify-center w-full">
          <PrimaryButton
            className="!bg-theme-yellow py-2 px-7 rounded-lg disabled:opacity-50"
            onClick={handleSubmit}
            disabled={!inputVales.email}
          >
            {t("resetPassword")}
          </PrimaryButton>
          <Link
            className="text-gray-600 capitalize underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm"
            to="/user-auth/login"
          >
            {t("backButton")}
          </Link>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
